export const TabletSize = 700;

export const DEFAULT_HEIGHT = 50;
export const DEFAULT_SIZE = 1;
